export const validateFormData = (data, validation) => {
  let errors = {};

  if (Array.isArray(data)) {
    data.map(item => {
      if (validation.required && validation.validEmail) {
        let email = new RegExp(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
        if (!email.test(item.trim())) {
          errors = validation.validEmail;
        }
      }
    });
  } else {
    for (let key in validation) {
      if (validation[key].required) {
        if (
          data[key] === undefined ||
          data[key] === null ||
          (typeof data[key] === "string" && data[key].trim() === "")
        ) {
          errors[key] = validation[key].required;
          continue;
        } else if (!data[key]) {
          if (data[key] === 0 || data[key] === false) {
            continue;
          } else {
            errors[key] = validation[key].required;
            continue;
          }
        }
      }
      if (validation[key].length) {
        if (data[key] && data[key].length !== validation[key].length.value) {
          errors[key] = validation[key].length.message;
          continue;
        }
      }
      if (validation[key].minLength) {
        if (data[key] && data[key].length < validation[key].minLength.value) {
          errors[key] = validation[key].minLength.message;
          continue;
        }
      }
      if (validation[key].maxLength) {
        if (data[key] && data[key].length > validation[key].maxLength.value) {
          errors[key] = validation[key].maxLength.message;
          continue;
        }
      }
      if (validation[key].type) {
        if (
          data[key] &&
          ((validation[key].type.value.toLowerCase() === "numeric" &&
            !/^[0-9]+$/.test(data[key])) ||
            (validation[key].type.value.toLowerCase() === "chars" &&
              !/^[a-zA-Z]+$/.test(data[key])) ||
            (validation[key].type.value.toLowerCase() === "uppercase" &&
              !/^[A-Z]+$/.test(data[key])) ||
            (validation[key].type.value.toLowerCase() === "lowercase" &&
              !/^[a-z]+$/.test(data[key])) ||
            (validation[key].type.value.toLowerCase() === "alphanumeric" &&
              !/^[a-zA-Z0-9]+$/.test(data[key])) ||
            (validation[key].type.value.toLowerCase() === "decimal" &&
              !/^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/.test(data[key])) ||
            (validation[key].type.value.toLowerCase() === "decimal2" &&
              !/^\s*(?=.*[0-9])\d*(?:\.\d{1,3})?\s*$/.test(data[key])) ||
            (validation[key].type.value.toLowerCase() ===
              "alphanumericspecial" &&
              /[&^\\\\@#*/|<>=%^,�\n\t]/.test(data[key])))
        ) {
          errors[key] = validation[key].type.message;
          continue;
        }
      }
      if (validation[key].validEmail) {
        let email = new RegExp(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
        if (!email.test(data[key])) {
          errors[key] = validation[key].validEmail;
          continue;
        }
      }
      if (validation[key].pattern) {
        let pattern = validation[key].pattern.value;
        if (data[key] && !pattern.test(data[key])) {
          errors[key] = validation[key].pattern.message;
          continue;
        }
      }
      if (validation[key].range) {
        let minValue = validation[key].range.minValue;
        let maxValue = validation[key].range.maxValue;
        if (
          ![undefined, null].includes(data[key]) &&
          (typeof Number(data[key]) != "number" ||
            !(data[key] >= minValue && data[key] <= maxValue))
        ) {
          errors[key] = validation[key].range.message;
          continue;
        }
      }
      if (validation[key].maxCharacter) {
        if (data[key].length > validation[key].maxCharacter.length) {
          errors[key] = validation[key].maxCharacter.message;
          continue;
        }
      }
      if (validation[key].validCustOrgName) {
        let name = new RegExp(/^[a-z0-9](?!.*--)[a-z0-9-]{1,61}[a-z0-9]$/);
        if (!name.test(data[key])) {
          errors[key] = validation[key].validCustOrgName;
          continue;
        }
      }
      if (validation[key].validIPAddress) {
        let ipReg = new RegExp(
          /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/gi
        );
        if (!ipReg.test(data[key])) {
          errors[key] = validation[key].validIPAddress;
          continue;
        }
      }
    }
  }
  return errors;
};

export const validateTargetData = (data, validation, type) => {
  let errors = {};
  for (let key in validation) {
    if (validation[key].required) {
      // let value = data.find((obj, index) => {
      //   return obj.id == key;
      // });

      let value = type.includes("ping") ? data[key].name : data[key].url;
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "")
      ) {
        errors[key] = validation[key].required;
        continue;
      }
      // else if (!value.name) {
      //   if (value === 0 || value === false) {
      //     continue;
      //   } else {
      //     errors[key] = validation[key].required;
      //     continue;
      //   }
      // }
    }
    if (validation[key].maxLength) {
      let value = type.includes("ping") ? data[key].name : data[key].url;
      if (value && value.length > validation[key].maxLength.value) {
        errors[key] = validation[key].maxLength.message;
        continue;
      }
    }
  }
  return errors;
};
